import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import {provideClientHydration, withEventReplay, withHttpTransferCacheOptions} from '@angular/platform-browser';
import {APP_ROUTES} from "./app.routes";
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {authHeaderInterceptor} from "./core/interceptors/auth-header.interceptor";
import {minizaemApiResponseInterceptor} from "./core/interceptors/minizaem-api-response.interceptor";
import {provideAnimations} from "@angular/platform-browser/animations";
import {CookieService} from "ngx-cookie-service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES,
      // withPreloading(PreloadAllModules),
      // withDebugTracing(),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([authHeaderInterceptor, minizaemApiResponseInterceptor]),
      withFetch(),
    ),
    provideAnimations(),
    provideClientHydration(
      // This enables the automatic caching of HTTP requests
      withHttpTransferCacheOptions({
        includePostRequests: false, // Usually keep this false
      }),
      withEventReplay(),
    ),
    CookieService,
  ]
};
